<template>
  <v-ons-list-item modifier="nodivider perfcours" :expandable="!!infosLink">
    <div class="center">
      Référence du contrat
    </div>
    <div class="right">
      {{ venteId }}
      <span v-if="infosLink" class="list-item__expand-chevron"></span>
    </div>
    <div v-if="infosLink" class="expandable-content">
      <v-ons-list modifier="noborder nopadding">
        <v-ons-list-item modifier="perfcours perfsub">
          <div class="center">
              Contrats liés
          </div>
          <div class="right">
            <template v-for="link in infosLink">
              {{ link.label ? link.label + ' • ' : '' }}
              {{ link.id }} • 
              {{ link.tonne }}t
              <br :key="link.id" />
            </template>
          </div>
        </v-ons-list-item>
      </v-ons-list>
    </div>
  </v-ons-list-item>
</template>

<script>
export default {
  props: ['venteId', 'infosLink'],
}
</script>

<style>
.list-item--perfsub__right {
  color: var(--perfarmer-gris-dark);
}
</style>